module.exports = __webpack_public_path__ + "static/media/docx-simple-icon.4ccf0646.svg";